<template>
  <v-btn
    v-bind="$attrs"
    v-on="$listeners"
  ><v-icon left class="mr-3">mdi-notebook-multiple</v-icon>{{ trans('settlement.settleUpBookings') }}
    <help-tooltip translation-key="settlement.settleUpBookingsHelp" :color="iconColor"/>
  </v-btn>
</template>

<script>
import {LocaleUtils} from '@/utils/locale-utils';
import HelpTooltip from '@/components/icons/HelpTooltip';

export default {
  name: 'SettlementUpdateBookingsButton',
  components: {HelpTooltip},
  mixins: [
    LocaleUtils
  ],
  computed: {
    iconColor() {
      return this.$attrs.color != null ? '' : undefined;
    }
  }
}
</script>

<style scoped>

</style>
